import React from 'react';

const ErrorState = ({ message = 'An error occurred', onRetry = null }) => {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-red-900/50 bg-red-950/30 p-8 text-center">
      <svg
        className="mx-auto h-12 w-12 text-red-400"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <p className="mt-4 text-sm font-medium text-red-200">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 rounded-lg border border-red-600 bg-red-600/20 px-4 py-2 text-sm font-medium text-red-300 transition-colors hover:bg-red-600/30"
        >
          Retry
        </button>
      )}
    </div>
  );
};

export default ErrorState;
